module.exports = __webpack_public_path__ + "templates/cart-count.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/restaurant/templates/cart-count.html
// module id = UBwx
// module chunks = 1